import React from "react";
import { useTranslation } from "react-i18next";
import "./TeensMaster.css";
import expertImage from "./../assets/Images/masters/m4.png"; // Replace with actual image path
import { useNavigate } from "react-router-dom";

const ExpertSection: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(); // ✅ Use translation hook

  return (
    <div className="expert-section">
      <div className="line"></div> {/* Top line */}
      
      <div className="expert-content">
        <img src={expertImage} alt={t("expert_name")} className="expert-image" />
        <div className="expert-text">
          <p className="expert-title">{t("expert_in_field")}</p> {/* ✅ Translated text */}
          <h3 className="expert-name">{t("expert_name")}</h3> {/* ✅ Translated name */}
          <button className="learn-more" onClick={() => navigate("/masters/m4")}>
            {t("learn_more")} {/* ✅ Translated button */}
          </button>
        </div>
      </div>

      <div className="line"></div> {/* Bottom line */}
    </div>
  );
};

export default ExpertSection;
